const lazyImages = [...document.querySelectorAll("img.lazy")];
const footer = document.querySelector("section.main-footer")

var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
               navigator.userAgent &&
               navigator.userAgent.indexOf('CriOS') == -1 &&
               navigator.userAgent.indexOf('FxiOS') == -1;

if(isSafari) {
  lazyImages.forEach(img => {
    img.src = img.dataset.src
    img.classList.remove("lazy");
  })
}

if ("IntersectionObserver" in window && !isSafari) {
  let lazyLoadObserver = new IntersectionObserver(function (
    entries,
    observer
  ) {
    // Loop through IntersectionObserverEntry objects
    entries.forEach(function (entry) {
      
      // Do these if the target intersects with the root
      if (entry.isIntersecting && entry.target.tagName === 'IMG') {
        let lazyImage = entry.target;
        lazyImage.src = lazyImage.dataset.src;
        lazyImage.classList.remove("lazy");
        lazyLoadObserver.unobserve(lazyImage);
      }
    });
  });

  // Loop through and observe each image
  lazyImages.forEach(function (lazyImage) {
    lazyLoadObserver.observe(lazyImage);
  });
}
window.addEventListener('load', () => {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();
  
        const containerOffset = document.querySelector(this.getAttribute('href')).offsetTop - 94
        window.scrollTo({
          top: containerOffset,
          behavior: 'smooth'
        })
    });
  });
})